import { CARRIER_COORDINATION as T } from "@/constants/testIds";
import { Zap, Eye, ClipboardList, BarChart3, MessagesSquare, Compass } from "lucide-react";

const cards = [
  { icon: Zap, title: "Faster Bookings", detail: "Turn requests into confirmed container bookings in minutes with structured carrier workflows instead of scattered email threads." },
  { icon: Eye, title: "Better Carrier Visibility", detail: "See every carrier, quote and confirmation side by side to make ocean freight coordination decisions with real context." },
  { icon: ClipboardList, title: "Reduced Manual Coordination", detail: "Eliminate repetitive follow-ups. Structured booking management keeps every carrier accountable to the same schedule." },
  { icon: BarChart3, title: "Shipment Transparency", detail: "Track vessel departure, ETA changes and container status in one shared view — no spreadsheets, no guesswork." },
  { icon: MessagesSquare, title: "Centralized Communication", detail: "Move carrier bookings, updates and documents from inboxes into a single Workspace built for shipment coordination." },
  { icon: Compass, title: "Operational Control", detail: "Give ops leaders end-to-end control across freight booking, documentation and export logistics coordination." },
];

export default function WhyMatters() {
  return (
    <section id="why-matters" data-testid={T.whyMatters} className="relative bg-[#fafbfd] py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-blue-brand">Why It Matters</p>
            <h2 className="mt-4 text-3xl font-semibold text-navy sm:text-4xl lg:text-[44px] lg:leading-[1.08]">
              Why Carrier Coordination Matters
            </h2>
          </div>
          <p className="max-w-md text-[15px] leading-relaxed text-slate-600">
            The teams that win in freight coordination don&rsquo;t work harder — they work from one system. Here&rsquo;s what changes when carrier booking management lives inside a Workspace.
          </p>
        </div>

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {cards.map(({ icon: Icon, title, detail }, i) => (
            <article
              key={title}
              className={`animate-fade-up group relative overflow-hidden rounded-2xl border border-slate-line bg-white p-7 transition hover:-translate-y-0.5 hover:shadow-card stagger-${(i % 6) + 1}`}
            >
              <div className="pointer-events-none absolute -right-8 -top-8 h-24 w-24 rounded-full bg-blue-soft opacity-0 blur-2xl transition group-hover:opacity-100" />
              <div
                className="relative flex h-11 w-11 items-center justify-center rounded-xl bg-navy text-white shadow-card"
                style={{ backgroundColor: "hsl(var(--navy))" }}
              >
                <Icon className="h-5 w-5" strokeWidth={1.8} />
              </div>
              <h3 className="relative mt-5 text-lg font-semibold text-navy">{title}</h3>
              <p className="relative mt-2.5 text-[14px] leading-relaxed text-slate-600">{detail}</p>
              <span className="relative mt-5 inline-flex items-center gap-1 text-[12px] font-medium text-blue-brand opacity-0 transition group-hover:opacity-100">
                Inside FreightIQ™ →
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
